import { BASE_URL } from "../api_const"

export const URL_CAPTURE_WP_INTEREST = BASE_URL + "/create/capture_interest"